module.exports = __webpack_public_path__ + "img/samsung-galaxy-s8.2a89d714.png";